import { gql } from "@apollo/client";

export const IdentityFileFieldsFragment = gql`
  fragment IdentityFileFields on IdentityFile {
    id
    url
    expirationDate
  }
`;
